import { NodeWrapper } from "./NodeWrapper";
import React, { memo, useEffect, useState, useCallback } from "react";
import { Box, Typography,  Chip, Paper,  FormControlLabel, Switch } from "@mui/material";
import { useTheme } from "@material-ui/core/styles";
import './css/inputNode.css';
import { QuestionAnswerOutlined as QuestionAnswer, Code as VariablesIcon, ContentCopy as ContentCopyIcon, DeleteOutline as DeleteOutlineIcon, Save as SaveIcon, Schedule as ScheduleIcon, GridOnOutlined as GridOn } from '@mui/icons-material';
import { i18n } from "../../../translate/i18n";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { processVariablesInText } from "../../../utils/variableUtils";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));
export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
  const theme = useTheme(); // Added this line
  const storageItems = useNodeStorage();
  const [processedQuestion, setProcessedQuestion] = useState(data.question || "");
  const [variableValue, setVariableValue] = useState("");
  const [isExecutionMode, setIsExecutionMode] = useState(false);
  const [alwaysAsk, setAlwaysAsk] = useState(data.alwaysAsk || false);
  const extractVariables = text => {
    if (!text) return [];
    const regex = /\$\{([^}]+)\}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1]);
    }
    return [...new Set(matches)];
  };
  const updateProcessedQuestion = useCallback(() => {
    const originalText = data.question || "";
    const newText = processVariablesInText(originalText);
    setProcessedQuestion(newText);
  }, [data.question]);
  useEffect(() => {
    const isExecutionPath = !window.location.pathname.includes('/flowbuilder-config');
    setIsExecutionMode(isExecutionPath);
    if (isExecutionPath && data.variableName) {
      const checkVariableValue = () => {
        if (window.flowVariables && window.flowVariables[data.variableName]) {
          setVariableValue(window.flowVariables[data.variableName]);
        }
      };
      checkVariableValue();
      const intervalId = setInterval(checkVariableValue, 1000);
      return () => clearInterval(intervalId);
    }
  }, [data.variableName]);
  useEffect(() => {
    updateProcessedQuestion();
    const handleVariableUpdate = () => {
      console.log('[inputNode] Detectada atualização de variáveis');
      updateProcessedQuestion();
    };
    window.addEventListener('flowVariableUpdate', handleVariableUpdate);
    return () => {
      window.removeEventListener('flowVariableUpdate', handleVariableUpdate);
    };
  }, [data.question, updateProcessedQuestion]);
  useEffect(() => {
    data.alwaysAsk = alwaysAsk;
  }, [alwaysAsk, data]);
  return <NodeWrapper id={id} selected={selected} color="#FFC400">
      <Handle type="target" position="left" style={{
      left: -12,
      top: "20px",
      background: "#FFC400",
      width: 10,
      height: 20,
      cursor: 'pointer',
      borderRadius: "4px",
      border: '2px solid white',
      zIndex: 1
    }} onConnect={params => console.log("handle onConnect", params)} isConnectable={isConnectable} />

      {/* Floating Toolbar (Outside Card) */}
      



      {/* Main Card (Unified Border) */}
      
        {/* Header */}
        <Box sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 1.5,
      borderBottom: "1px solid #f1f5f9",
      
      bgcolor: "#FFC400",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
      color: "#ffffff"
    }}>
          <Box sx={{
        display: "flex", alignItems: "center", gap: 1, flexGrow: 1
      }}>
            <QuestionAnswer sx={{ width: "20px", height: "20px", color: "#ffffff", filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.7))" }} />
            <div style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textShadow: "0px 1px 4px rgba(0,0,0,0.8)" }}>
              {data.name || i18n.t("flowBuilder.editor.nodes.input.name")}
</div>
          
        
</Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {data.remarketingEnabled && <Tooltip title={`${i18n.t("flowBuilder.remarketing.title")} (${data.remarketingTasks?.length || 0})`}>
              <Chip icon={<ScheduleIcon style={{
          fontSize: 14,
          color: '#b45309'
        }} />} label={data.remarketingTasks?.length || 0} size="small" sx={{
          height: 20,
          fontSize: '0.7rem',
          bgcolor: '#fef3c7',
          color: '#b45309',
          '& .MuiChip-icon': {
            ml: 0.5
          }
        }} />
            </Tooltip>}
          <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.input.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.input.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
        </Box>
</Box>

        {/* Content */}
        <Box sx={{
      p: 1.5,
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5
    }}>
          <Paper elevation={0} sx={{
        bgcolor: '#f8fafc',
        p: 1.5,
        borderRadius: 1,
        minHeight: '60px',
        overflow: 'auto',
        maxHeight: '150px',
        wordBreak: 'break-word',
        border: '1px solid #f1f5f9'
      }}>
            <Typography variant="caption" color="text.secondary" sx={{
          display: 'block',
          mb: 0.5,
          fontWeight: 400,
          fontFamily: "'Inter', 'Roboto', sans-serif"
        }}>
              {i18n.t("flowBuilder.editor.nodes.input.question")}:
            </Typography>

            {data.question ? <Box>
                {!isExecutionMode ? data.question.split(/\$\{([^}]+)\}/).map((part, index) => {
            if (index % 2 === 0) {
              return <Typography key={index} variant="body2" component="span" fontSize="13px" color="#334155">{part}</Typography>;
            } else {
              return <Chip key={index} label={part} size="small" sx={{
                height: 20,
                fontSize: '0.75rem',
                bgcolor: '#ede9fe',
                color: "#ffffff",
                border: 'none',
                my: 0.25,
                mx: 0.5,
                '& .MuiChip-label': {
                  px: 1
                }
              }} />;
            }
          }) : <Typography variant="body2" color="#334155">{processedQuestion}</Typography>}
              </Box> : <Typography variant="body2" color="text.secondary" sx={{
          fontStyle: 'italic',
          fontSize: '13px'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.undefinedQuestion")}
              </Typography>}
          </Paper>

          <Box sx={{ position: 'relative' }}>
          <Paper elevation={0} sx={{
        bgcolor: '#f8fafc',
        p: 1,
        borderRadius: 1,
        minHeight: '40px',
        overflow: 'auto',
        wordBreak: 'break-word',
        border: '1px solid #f1f5f9',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
            <Typography variant="caption" color="text.secondary" sx={{
          fontWeight: 400,
          fontFamily: "'Inter', 'Roboto', sans-serif"
        }}>
              {i18n.t("flowBuilder.editor.nodes.input.variableLabel")}:
            </Typography>

            {data.variableName ? <Box sx={{
          display: 'flex',
          alignItems: 'center'
        }}>
                <Chip label={data.variableName} size="small" sx={{
            height: 24,
            fontSize: '0.85rem',
            bgcolor: '#1e293b',
            color: '#ffffff',
            border: '1px solid #e2e8f0',
            '& .MuiChip-label': {
              px: 1.5
            }
          }} />

                {isExecutionMode && variableValue && <Tooltip title={`${i18n.t("flowBuilder.editor.nodes.input.valueLabel")}: ${variableValue}`}>
                    <Box sx={{
              ml: 1.5,
              p: 0.5,
              borderRadius: 1,
              bgcolor: '#bae6fd',
              color: '#0369a1',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5
            }}>
                      <SaveIcon fontSize="small" sx={{
                width: 14,
                height: 14
              }} />
                    </Box>
                  </Tooltip>}
              </Box> : <Typography variant="body2" color="text.secondary" sx={{
          fontStyle: 'italic',
          fontSize: '12px'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.undefinedVariable")}
              </Typography>}
          </Paper>
          <Handle type="source" position="right" id="a" style={{
            position: "absolute", right: -24, top: "50%", transform: "translateY(-50%)", background: "#FFC400", width: 10, height: 20, cursor: 'pointer', borderRadius: "4px", border: '2px solid white', zIndex: 1
          }} isConnectable={isConnectable} />
          </Box>

          {data.question && data.question.includes("${") && <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
        bgcolor: '#fdf4ff',
        p: 0.75,
        borderRadius: 1
      }}>
              <VariablesIcon fontSize="small" sx={{
          color: '#d946ef',
          width: 16,
          height: 16
        }} />
              <Typography variant="caption" sx={{
          color: '#d946ef'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.usingVariables")}: {extractVariables(data.question).join(', ')}
              </Typography>
            </Box>}

          <Box sx={{
        mt: 0,
        p: 0,
        display: 'flex',
        justifyContent: 'flex-end'
      }}>
            <FormControlLabel control={<Switch checked={alwaysAsk} onChange={e => setAlwaysAsk(e.target.checked)} size="small" color="primary" />} label={<Typography variant="caption" sx={{
          fontSize: '0.75rem',
          color: '#64748b'
        }}>
                  {i18n.t("flowBuilder.editor.nodes.input.alwaysAsk")}
                </Typography>} labelPlacement="start" sx={{
          m: 0
        }} />
          </Box>
        </Box>

        {/* Remarketing Handles Section */}
        {data.remarketingEnabled && data.remarketingTasks && data.remarketingTasks.length > 0 && <div style={{
      borderTop: "1px solid #f1f5f9"
    }}>
            <div style={{
        padding: "8px 12px",
        backgroundColor: "#fef3c7",
        fontSize: "11px",
        fontWeight: 400,
        fontFamily: "'Inter', 'Roboto', sans-serif",
        color: "#b45309",
        
      }}>
              {i18n.t("flowBuilder.remarketing.title") || "Remarketing"}
            </div>

            {/* [ANTIGRAVITY] Robust Rendering: Sort by order and deduct key safely */}
            {[...data.remarketingTasks].sort((a, b) => (a.order || 0) - (b.order || 0)).map((task, index, array) => {
        const isFinal = task.isFinalTask || task.closeTicket; // Detect final task
        const isLastItem = index === array.length - 1;
        const isInactive = task.active === false;

        // [ANTIGRAVITY] Fix: Use real background and borderLeft to ensure visibility
        const bgStyle = isFinal ? "#fff0f5" : "white";
        return <div key={`${task.id}-${index}`} style={{
          position: "relative",
          padding: "8px 20px 8px 12px",
          borderBottom: !isLastItem ? "1px solid #f1f5f9" : "none",
          borderLeft: isFinal ? "4px solid #e91e63" : "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: bgStyle,
          fontSize: "12px",
          color: "#334155",
          borderBottomLeftRadius: isLastItem ? "10px" : "0",
          borderBottomRightRadius: isLastItem ? "10px" : "0",
          opacity: isInactive ? 0.6 : 1,
          textDecoration: isInactive ? "line-through" : "none"
        }}>
                    <div style={{
            flex: 1,
            marginRight: "40px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            overflow: 'hidden'
          }}>
                      <div style={{
              display: "flex",
              flexDirection: "column",
              minWidth: "30px",
              gap: "4px"
            }}>
                        {isFinal ? <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                            <GridOn style={{
                  width: "14px",
                  height: "14px",
                  color: "#880e4f"
                }} />
                            <span style={{
                  fontWeight: "bold",
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                  color: "#e91e63",
                  fontSize: "12px"
                }}>
                              {i18n.t("flowBuilder.remarketing.fin") || "FIN"}
                            </span>
                            <span style={{
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                  fontSize: '11px',
                  fontStyle: 'italic',
                  color: '#e91e63',
                  marginLeft: "8px"
                }}>
                              {i18n.t("flowBuilder.remarketing.autoClose") || "Auto-Cierre"}
                            </span>
                          </div> : <span style={{
                fontWeight: 500,
                fontFamily: "'Inter', 'Roboto', sans-serif",
                color: "#b45309",
                fontSize: "11px"
              }}>
                            {isInactive ? i18n.t("flowBuilder.remarketing.inactiveTask") || "[INACTIVA]" : `#${task.order || index + 1}`}
                          </span>}
                        <span style={{
                fontFamily: "'Inter', 'Roboto', sans-serif",
                fontSize: "11px",
                color: isFinal ? "#e91e63" : "#64748b"
              }}>
                          {task.waitUnit === 'days' ? `${task.waitTime}d` : task.waitUnit === 'hours' ? `${task.waitTime}h` : task.waitUnit === 'minutes' ? `${task.waitTime}m` : `${task.waitTime}m`}
                        </span>
                      </div>

                      {task.variable && !isFinal && <Chip label={task.variable} size="small" sx={{
              height: 22,
              fontSize: '0.75rem',
              bgcolor: '#fff',
              color: '#f59e0b',
              border: '1px solid #e2e8f0',
              '& .MuiChip-label': {
                px: 1.5
              }
            }} />}

                      {isFinal && <span style={{
              fontSize: '10px',
              fontStyle: 'italic',
              color: '#ad1457'
            }}>
                          {i18n.t("flowBuilder.remarketing.automaticTag") || "Automática"}
                        </span>}
                    </div>

                    <Handle type="source" position="right" id={`remarketing-${task.order}`} style={{
            background: isFinal ? "#e91e63" : "#f59e0b",
            width: 10,
            height: 20,
            borderRadius: "4px",
            right: -12,
            cursor: 'pointer',
            border: '2px solid white',
            zIndex: 10
          }} isConnectable={isConnectable} />
                  </div>;
      })}
          </div>}
      

      
    </NodeWrapper>;
});
